import { useState } from "react";
import useModal from "../../hooks/useModal";
import AlertsTemplate from "../../templates/AlertsTemplate/AlertsTemplate";
import FormModal from "../../components/organisms/FormModal/FormModal";

const AlertsScreen = () => {
  const { isOpen, open, close } = useModal();
  const [userType, setUserType] = useState("institution");

  const handleRequestAccess = (type) => {
    setUserType(type);
    open();
  };

  return (
    <>
      <AlertsTemplate onRequestAccess={handleRequestAccess} />
      <FormModal
        isOpen={isOpen}
        userType={userType}
        onClose={close}
        onChangeUserType={setUserType}
      />
    </>
  );
};

export default AlertsScreen;
